/**
 * Modal component
 */

class ModalComponent extends HTMLElement {
	constructor() {
		super();

		const currentModalId = this.getAttribute('id');
		const btnOpenElement = document.querySelectorAll('a[data-modal-target="' + currentModalId + '"]');
		const closeModalButton = this.querySelectorAll('[data-close="modal"]');
		const dontShowButton = this.querySelector('tpt-dont-show');
		const modalHeader = this.querySelector('tpt-modal-header');

		modalHeader.addEventListener('touchmove', this.closeModal);
		this.addEventListener('click', this.closeModalComponent);
		this.addEventListener('keydown', this.keyDown.bind(this));

		btnOpenElement.forEach((element) => {
			element.addEventListener('click', this.showModal.bind(this));
		});

		if (dontShowButton) {
			dontShowButton.addEventListener('click', this.dontShowModalAgain);
		}

		if (sessionStorage.getItem('modal-dont-show-' + currentModalId) === 'false' || sessionStorage.getItem('modal-dont-show-' + currentModalId) === null) {
			if (this.getAttribute('data-auto-open') == 'true') {
				let timeDelay = 0;
				const autoOpenModal = this;

				if (autoOpenModal.getAttribute('data-time-delay')) {
					timeDelay = autoOpenModal.getAttribute('data-time-delay') * 1000;
				}

				setTimeout(function () {
					autoOpenModal.classList.add('show');
					document.getElementsByTagName('html')[0].classList.add('open-modal');
				}, timeDelay);
			}
		}

		closeModalButton.forEach((element) => {
			element.addEventListener('click', this.closeModal);
		});
	}

	showModal(e) {
		e.preventDefault();
		const modal = this;
		this._triggerElement = e.currentTarget;

		const modalId = this.getAttribute('id');
		const btnOpenModal = document.querySelector('[data-modal-target="' + modalId + '"]');

		const focusElement = this.querySelector('[data-close]');

		setTimeout(() => {
			trapFocus(modal, focusElement);
		}, 300);

		if (btnOpenModal.classList.contains('active')) {
			btnOpenModal.classList.remove('active');
			btnOpenModal.setAttribute('aria-expanded', false);
			document.getElementsByTagName('html')[0].classList.remove('open-modal');
			this.classList.remove('show');

			return;
		} else {
			btnOpenModal.classList.add('active');
			btnOpenModal.setAttribute('aria-expanded', true);
			document.getElementsByTagName('html')[0].classList.add('open-modal');
			this.classList.add('show');

			this.scrollTop = 0;

			return;
		}
	}

	keyDown(e) {
		if (e.keyCode === 27) {
			this.closeModal();
		}
	}

	closeModal() {
		const closeButton = this;

		const modal = this.closest('tpt-modal-component');

		const currentModalId = this.closest('tpt-modal-component').getAttribute('id');
		const btnDontShow = this.closest('tpt-modal-component').querySelector('tpt-dont-show');

		if (btnDontShow) {
			if (btnDontShow.classList.contains('active')) {
				sessionStorage.setItem('modal-dont-show-' + currentModalId, 'true');
			} else {
				sessionStorage.setItem('modal-dont-show-' + currentModalId, 'false');
			}
		}

		this.closest('tpt-modal-component').classList.remove('show');

		const buttonModal = document.querySelectorAll('[data-modal-target="' + currentModalId + '"]');

		if (buttonModal) {
			buttonModal.forEach((buttonTarget) => {
				buttonTarget.classList.remove('active');
				buttonTarget.setAttribute('aria-expanded', false);
			});
		}

		setTimeout(function () {
			const modalCount = document.querySelectorAll('tpt-modal-component.show').length;

			if (modalCount < 1) {
				document.getElementsByTagName('html')[0].classList.remove('open-modal');
			}
		}, 200);

		setTimeout(() => {
			if (modal._triggerElement) {
				modal._triggerElement.focus();
			}
		}, 300);
	}

	closeModalComponent(e) {
		if (e.target !== this) {
			return;
		} else {
			this.closeModal();
		}
	}

	dontShowModalAgain() {
		this.classList.toggle('active');
	}
}

customElements.define('tpt-modal-component', ModalComponent);

class OpenModalComponent extends HTMLElement {
	constructor() {
		super();

		this.addEventListener('click', this.openModal);
		this.addEventListener('keypress', this.keyPress);
	}

	keyPress(e) {
		if (e.key === 'Enter') {
			this.openModal(e);
		}
	}

	openModal(e) {
		e.preventDefault();

		const modalId = this.getAttribute('data-modal-target');
		const modalComponent = document.getElementById(modalId);
		modalComponent._triggerElement = this;

		modalComponent.showModal(e);
	}
}

customElements.define('tpt-open-modal', OpenModalComponent);

/**
 * Init swiper slider
 */
class SwiperSliderComponent extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		const swiper = this.querySelector('.swiper');
		const optionString = this.querySelector('tpt-slider-options').innerHTML;
		const optionsJson = JSON.parse(optionString);
		const nextButton = this.querySelector('.swiper-button-next');
		const prevButton = this.querySelector('.swiper-button-prev');

		let options = {
			...optionsJson,
			navigation: {
				nextEl: nextButton,
				prevEl: prevButton,
			},
		};

		new Swiper(swiper, options);
	}
}

customElements.define('tpt-slider-component', SwiperSliderComponent);

/**
 * Popup inner product variants
 */
class PopupVariantsModal extends HTMLElement {
	constructor() {
		super();

		const btnCloseModal = this.querySelector('[data-close="modal-variant"]');
		btnCloseModal.addEventListener('click', this.closeModalVariant.bind(this));
		this.addEventListener('click', this.closeModalVariantComponent);
		this.addEventListener('keydown', this.closeModalComponentEsc.bind(this));
	}

	closeModalComponentEsc(e) {
		if (e.keyCode === 27) {
			this.closeModalVariant();
		}
	}

	closeModalVariant() {
		const currentModal = this.closest('tpt-modal-component');
		//const currentModalCart = this.closest('cart-drawer');

		this.remove();

		if (currentModal) {
			currentModal.focus();
		}

		setTimeout(() => {
			document.querySelector('cart-drawer').cartFocus();
		}, 300);

		// if (currentModalCart) {
		// 	currentModalCart.focus();
		// }
	}

	closeModalVariantComponent(e) {
		if (e.target !== this) {
			return;
		} else {
			const windowWith = window.innerWidth;

			if (windowWith <= 1024) {
				this.remove();
			}
		}
	}
}
customElements.define('tpt-modal-variants', PopupVariantsModal);
/**
 * Tab popup component
 */

class PopupTabs extends HTMLElement {
	constructor() {
		super();

		const btnOpen = document.querySelectorAll('[data-tab-popup-target]');

		btnOpen.forEach((btnItem) => {
			btnItem.addEventListener('click', this.showModal);
		});
	}

	showModal(e) {
		e.preventDefault();

		const currentModalId = this.getAttribute('data-tab-popup-target');
		const currentModal = document.getElementById(currentModalId);
		const currentTabTrigger = this.getAttribute('data-item-tab-target');

		currentModal.querySelector('[data-tab-target="' + currentTabTrigger + '"]').click();

		document.getElementsByTagName('html')[0].classList.add('open-modal');
		currentModal.classList.add('show');
		this.scrollTop = 0;
	}
}

customElements.define('tpt-popup-tab', PopupTabs);

/**
 * Tabs component
 */
class TabItem extends HTMLElement {
	constructor() {
		super();
		this.addEventListener('click', this.displayTabContainer.bind(this));
		this.addEventListener('keypress', this.keyPress.bind(this));
	}

	keyPress(event) {
		if (event.key === 'Enter') {
			this.displayTabContainer(event);
		}
	}

	displayTabContainer(event) {
		event.preventDefault();

		const tabContainerTarget = this.getAttribute('data-tab-target');
		const tabAjaxUrl = this.getAttribute('data-ajax-url');

		if (tabAjaxUrl && !this.classList.contains('loaded')) {
			this.closest('tpt-tabs-component').classList.add('component-loading');
			this.classList.add('loading');

			if (this.classList.contains('active')) {
				return;
			} else {
				const ajaxDataElement = this.closest('tpt-tabs-component').querySelector('[data-ajax-content="' + tabContainerTarget + '"]');

				fetch(tabAjaxUrl)
					.then((response) => response.text())
					.then((responseText) => {
						const elementToGet = this.getAttribute('data-ajax-element');

						const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');

						if (elementToGet) {
							const tabContentHtml = responseHTML.querySelector(elementToGet);
							ajaxDataElement.innerHTML = tabContentHtml.innerHTML;
						} else {
							ajaxDataElement.innerHTML = responseText;
						}
					})
					.finally(() => {
						this.activeTabContainer();
						this.classList.add('loaded');
						this.classList.remove('loading');
						this.closest('tpt-tabs-component').classList.remove('component-loading');
					});
			}
		} else {
			if (this.classList.contains('active')) {
				return;
			} else {
				this.activeTabContainer();
			}
		}
	}

	activeTabContainer() {
		const currentTabContainer = this.closest('tpt-tabs-component');
		const tabContainerTarget = this.getAttribute('data-tab-target');

		currentTabContainer.querySelectorAll('tpt-tab-item').forEach((element) => {
			element.classList.remove('active');
		});

		this.classList.add('active');

		currentTabContainer.querySelectorAll('tpt-tab-data').forEach((element) => {
			element.classList.remove('active');
		});

		currentTabContainer.querySelector('[data-tab-container="' + tabContainerTarget + '"]').classList.add('active');
	}
}

customElements.define('tpt-tab-item', TabItem);

/**
 * Accordion component
 */
class AccordionHeader extends HTMLElement {
	constructor() {
		super();
		this.addEventListener('click', this.displayAccordionContainer.bind(this));
		this.addEventListener('keypress', this.keyPress);
	}

	keyPress(e) {
		if (e.key === 'Enter') {
			this.displayAccordionContainer(e);
		}
	}

	displayAccordionContainer(event) {
		event.preventDefault();

		const currentAccordion = this.closest('tpt-accordion-component');
		const currentAccordionItem = this.closest('tpt-accordion-item');

		if (currentAccordion.getAttribute('data-type') == 'group') {
			if (currentAccordionItem.classList.contains('active')) {
				currentAccordionItem.classList.remove('active');
				return;
			} else {
				currentAccordion.querySelectorAll('tpt-accordion-item').forEach((element) => {
					element.classList.remove('active');
				});

				currentAccordionItem.classList.add('active');
				return;
			}
		} else {
			currentAccordionItem.classList.toggle('active');
		}
	}
}

customElements.define('tpt-accordion-title', AccordionHeader);

class ProductGallery extends HTMLElement {
	constructor() {
		super();

		const galleryContainer = this;
		const mainSwiper = this.querySelector('.gallery-main .swiper');
		const mainNext = this.querySelector('.gallery-main .swiper-button-next');
		const mainPrev = this.querySelector('.gallery-main .swiper-button-prev');
		const thumbsColumns = parseInt(this.getAttribute('data-thumbs-column'));

		const thumbSwiper = this.querySelector('.gallery-thumb .swiper');
		const thumbNext = this.querySelector('.gallery-thumb .swiper-button-next');
		const thumbPrev = this.querySelector('.gallery-thumb .swiper-button-prev');

		var swiperThumb = new Swiper(thumbSwiper, {
			spaceBetween: 6,
			autoHeight: false,
			allowTouchMove: true,
			navigation: {
				nextEl: thumbNext,
				prevEl: thumbPrev,
			},
			keyboard: {
				enabled: true,
			},
			breakpoints: {
				0: {
					slidesPerView: thumbsColumns,
				},
				768: {
					slidesPerView: thumbsColumns,
				},
				1280: {
					slidesPerView: thumbsColumns,
				},
			},
		});

		var swiperMain = new Swiper(mainSwiper, {
			spaceBetween: 16,
			autoHeight: false,
			allowTouchMove: true,
			navigation: {
				nextEl: mainNext,
				prevEl: mainPrev,
			},
			keyboard: {
				enabled: true,
			},
			breakpoints: {
				0: {
					slidesPerView: 1,
				},
				768: {
					slidesPerView: 1.5,
				},
				1280: {
					slidesPerView: 1.5,
				},
			},
			thumbs: {
				swiper: swiperThumb,
			},
		});

		swiperMain.on('transitionEnd', function () {
			//window.pauseAllMedia();

			if (mainSwiper.querySelector('.swiper-slide-active')) {
				const slideMediaType = mainSwiper.querySelector('.swiper-slide-active').getAttribute('data-media-type');

				if (slideMediaType == 'video' || slideMediaType == 'model') {
					galleryContainer.classList.add('hidden-lightbox');
					swiperMain.allowTouchMove = false;
				} else {
					galleryContainer.classList.remove('hidden-lightbox');
					swiperMain.allowTouchMove = true;
				}
			}
		});
	}
}

customElements.define('tpt-product-gallery', ProductGallery);

/**
 * Galllery featured product
 */
class ProductGalleryFeatured extends HTMLElement {
	constructor() {
		super();

		const galleryContainer = this;
		const mainSwiper = this.querySelector('.gallery-main .swiper');
		const mainNext = this.querySelector('.gallery-main .swiper-button-next');
		const mainPrev = this.querySelector('.gallery-main .swiper-button-prev');

		var swiperMain = new Swiper(mainSwiper, {
			slidesPerView: 1,
			spaceBetween: 20,
			autoHeight: false,
			allowTouchMove: true,
			navigation: {
				nextEl: mainNext,
				prevEl: mainPrev,
			},
			keyboard: {
				enabled: true,
			},
		});

		swiperMain.on('transitionEnd', function () {
			window.pauseAllMedia();

			if (mainSwiper.querySelector('.swiper-slide-active')) {
				const slideMediaType = mainSwiper.querySelector('.swiper-slide-active').getAttribute('data-media-type');

				if (slideMediaType == 'video' || slideMediaType == 'model') {
					galleryContainer.classList.add('hidden-lightbox');
					swiperMain.allowTouchMove = false;
				} else {
					galleryContainer.classList.remove('hidden-lightbox');
					swiperMain.allowTouchMove = true;
				}
			}
		});
	}
}

customElements.define('tpt-product-gallery-featured', ProductGalleryFeatured);
/**
 * Gallery lightbox
 */

/**
 * Video
 */

class PlayVideo extends HTMLElement {
	constructor() {
		super();

		this.addEventListener('click', this.playVideo);
	}

	playVideo() {
		const videoId = this.getAttribute('data-poster-id');

		setTimeout(() => {
			document.getElementById(videoId).click();
		}, 500);
	}
}

customElements.define('tpt-play-video', PlayVideo);

/**
 * Open sidebar menu
 */
class TptMenuDrawer extends HTMLElement {
	constructor() {
		super();

		this.defaultColor = this.getAttribute('data-default-color');

		this.addEventListener('click', this.openModal);
		this.addEventListener('keypress', this.keyPress);
	}

	keyPress(e) {
		if (e.key === 'Enter') {
			this.openModal(e);
		}
	}

	openModal(e) {
		e.preventDefault();

		const modalId = this.getAttribute('data-modal-target');
		const modalComponent = document.getElementById(modalId);

		//const btnOpenModal = this;

		if (this.classList.contains('active')) {
			this.classList.remove('active');
			this.setAttribute('aria-expanded', false);
			this.closest('.change-color-header').classList.remove(this.defaultColor);
			document.getElementsByTagName('html')[0].classList.remove('open-modal', 'header-menu-drawer');
			modalComponent.classList.remove('show');

			setTimeout(() => {
				modalComponent.focus();
			}, 300);

			return;
		} else {
			this.classList.add('active');
			this.setAttribute('aria-expanded', true);
			this.closest('.change-color-header').classList.add(this.defaultColor);
			document.getElementsByTagName('html')[0].classList.add('open-modal', 'header-menu-drawer');
			modalComponent.classList.add('show');

			setTimeout(() => {
				modalComponent.focus();
			}, 300);

			return;
		}
	}
}

customElements.define('tpt-menu-drawer', TptMenuDrawer);

/**
 * Copy text to clipboard
 */

var clipboardTimeoout;

class CopyClipboard extends HTMLElement {
	constructor() {
		super();

		this.addEventListener('click', this.copyClipboard.bind(this));
	}

	copyClipboard() {
		clearTimeout(clipboardTimeoout);

		const text = this.querySelector('.tpt-clipboard__text').value;

		navigator.clipboard.writeText(text);

		this.classList.add('copied');

		clipboardTimeoout = setTimeout(() => {
			this.classList.remove('copied');
		}, 4000);
	}
}

customElements.define('tpt-copy-clipboard', CopyClipboard);

/**
 * Account tab login register
 */

class TptTabAccount extends HTMLElement {
	constructor() {
		super();

		const tabItems = this.querySelectorAll('.tpt-tab-account__list-item');
		const linkChange = this.querySelectorAll('tpt-tab-account-change');
		linkChange.forEach((link) => {
			link.addEventListener('click', this.showTabChange);
		});

		tabItems.forEach((tabItem) => {
			tabItem.addEventListener('click', this.showTab);
		});
	}

	showTabChange() {
		const tabTarget = this.getAttribute('data-customer-target');
		document.querySelector(`tpt-tab-account [data-target="${tabTarget}"]`).click();
	}

	showTab() {
		if (!this.classList.contains('active')) {
			const currentUrl = window.location.href;
			const tabAccountComponent = this.closest('tpt-tab-account');
			const tabDataId = this.getAttribute('data-target');

			console.log(currentUrl);

			if (currentUrl.indexOf('account/login') !== -1) {
				console.log('Page login');
			}

			tabAccountComponent.querySelectorAll('.tpt-tab-account__content').forEach((tabData) => {
				tabData.classList.remove('active');
			});

			tabAccountComponent.querySelectorAll('.tpt-tab-account__list-item').forEach((tabItem) => {
				tabItem.classList.remove('active');
			});

			this.classList.add('active');
			document.getElementById(tabDataId).classList.add('active');
		}
	}
}

customElements.define('tpt-tab-account', TptTabAccount);

/**
 * Check password
 */

function containsUppercase(str) {
	return /[A-Z]/.test(str);
}

function containsLowcase(str) {
	return /[a-z]/.test(str);
}

function containsNumber(str) {
	return /[0-9]/.test(str);
}

class TptPassRequirements extends HTMLElement {
	constructor() {
		super();

		const passInput = this.querySelector('[type="password"]');

		passInput.addEventListener('keyup', this.checkPass);
	}

	checkPass() {
		const passRequirements = this.closest('tpt-pass-requirements');

		let min = false;
		let number = false;
		let uppercase = false;
		let lowercase = false;

		const passString = this.value;
		const buttonSubmit = passRequirements.querySelector('[data-button-submit]');
		const reMin = passRequirements.querySelector('[data-requirements-min]');

		if (passString.length >= 8) {
			min = true;

			if (reMin) {
				reMin.classList.add('active');
			}
		} else {
			min = false;

			if (reMin) {
				reMin.classList.remove('active');
			}
		}

		if (containsUppercase(passString)) {
			uppercase = true;
			passRequirements.querySelector('[data-requirements-uppercase]').classList.add('active');
		} else {
			uppercase = false;
			passRequirements.querySelector('[data-requirements-uppercase]').classList.remove('active');
		}

		if (containsLowcase(passString)) {
			lowercase = true;
			passRequirements.querySelector('[data-requirements-lowercase]').classList.add('active');
		} else {
			lowercase = false;
			passRequirements.querySelector('[data-requirements-lowercase]').classList.remove('active');
		}

		if (containsNumber(passString)) {
			number = true;
			passRequirements.querySelector('[data-requirements-number]').classList.add('active');
		} else {
			number = false;
			passRequirements.querySelector('[data-requirements-number]').classList.remove('active');
		}

		if (min && number && uppercase && lowercase) {
			buttonSubmit.removeAttribute('disabled');
		} else {
			buttonSubmit.setAttribute('disabled', 'disabled');
		}
	}
}

customElements.define('tpt-pass-requirements', TptPassRequirements);

/**
 * Login / Register
 */
if (!customElements.get('tpt-login-register')) {
	customElements.define(
		'tpt-login-register',
		class TptLoginRegister extends HTMLElement {
			constructor() {
				super();

				this.addEventListener('click', this.showLoginRegister.bind(this));
			}

			showLoginRegister() {
				const modal = document.getElementById('customer-auth');
				const modalContentTarget = this.getAttribute('data-content');
				const customerFormActive = document.getElementById(modalContentTarget);

				const customerForms = modal.querySelectorAll('.customer-form');

				customerForms.forEach((form) => {
					form.style.display = 'none';
				});

				customerFormActive.style.display = 'block';

				modal.classList.add('show');
				document.getElementsByTagName('html')[0].classList.add('open-modal');
			}
		},
	);
}

/**
 * Dropdown
 */

if (!customElements.get('tpt-dropdown')) {
	customElements.define(
		'tpt-dropdown',
		class TptDropdown extends HTMLElement {
			constructor() {
				super();

				const button = this.querySelector('tpt-dropdown-button');

				button.addEventListener('click', this.toggleDropdown.bind(this));
			}

			toggleDropdown() {
				this.classList.toggle('active');
			}
		},
	);
}

/**
 * Init swiper scroll
 */
let nextSectionFlag = false;
let prevSectionFlag = false;

class SwiperScrollComponent extends HTMLElement {
	constructor() {
		super();

		this.addEventListener('wheel', this.swiperScroll.bind(this));
		this.section = this.closest('section');
		this.nextSection = this.section.nextElementSibling;
		this.prevSection = this.section.previousElementSibling;
	}

	connectedCallback() {
		const swiper = this.querySelector('.swiper');
		const section = this.closest('section');
		const optionString = this.querySelector('tpt-slider-options').innerHTML;
		const optionsJson = JSON.parse(optionString);
		const nextButton = this.querySelector('.swiper-button-next');
		const prevButton = this.querySelector('.swiper-button-prev');

		let options = {
			...optionsJson,
			navigation: {
				nextEl: nextButton,
				prevEl: prevButton,
			},
		};

		var swiperScroll = new Swiper(swiper, options);

		swiperScroll.on('transitionStart', function () {
			section.scrollIntoView({ behavior: 'smooth' });
		});

		swiperScroll.on('transitionEnd', function () {
			if (swiper.querySelector('.swiper-slide:last-child').classList.contains('swiper-slide-active')) {
				nextSectionFlag = true;
			}

			if (swiper.querySelector('.swiper-slide:first-child').classList.contains('swiper-slide-active')) {
				prevSectionFlag = true;
			}
		});
	}

	swiperScroll(event) {
		if (nextSectionFlag && event.deltaY > 0) {
			this.nextSection.scrollIntoView({ behavior: 'smooth' });
		}

		if (prevSectionFlag && event.deltaY < 0) {
			this.prevSection.scrollIntoView({ behavior: 'smooth' });
		}

		nextSectionFlag = false;
		prevSectionFlag = false;
	}
}

customElements.define('tpt-swiper-scroll-component', SwiperScrollComponent);

/**
 * Custom page navigation
 */

if (!customElements.get('tpt-pagination')) {
	customElements.define(
		'tpt-pagination',
		class TptPagination extends HTMLElement {
			constructor() {
				super();

				const inputPage = this.querySelector('.tpt-change-page');

				if (inputPage) {
					inputPage.addEventListener('keypress', this.changePage);
				}
			}

			changePage(event) {
				if (event.key === 'Enter') {
					const curentUrlString = window.location.href;
					var curentUrl = new URL(curentUrlString);
					var search_params = curentUrl.searchParams;
					const pageValue = this.value;

					search_params.set('page', pageValue);
					curentUrl.search = search_params.toString();
					var newUrl = curentUrl.toString();
					window.location.href = newUrl;
				}
			}
		},
	);
}

/**
 * Section header swiper navigation trigger
 */

if (!customElements.get('tpt-swiper-nav')) {
	customElements.define(
		'tpt-swiper-nav',
		class TptSwiperNav extends HTMLElement {
			constructor() {
				super();

				this.section = this.closest('.shopify-section');

				this.addEventListener('click', this.triggerSwiperNavigation.bind(this));
			}

			triggerSwiperNavigation() {
				const type = this.getAttribute('data-type');

				console.log(type);

				if (type == 'next') {
					this.section.querySelector('.tpt-theme-section_body .tpt-swiper-button-next').click();
				} else {
					this.section.querySelector('.tpt-theme-section_body .tpt-swiper-button-prev').click();
				}
			}
		},
	);
}

/**
 * Swiper slider sync
 */

if (!customElements.get('tpt-slider-component-sync')) {
	customElements.define(
		'tpt-slider-component-sync',
		class TptDropdown extends HTMLElement {
			constructor() {
				super();
			}

			connectedCallback() {
				const swiperMain = this.querySelector('tpt-slider-component-sync-main .swiper');
				const swiperThums = this.querySelector('tpt-slider-component-sync-thumb .swiper');

				const optionStringMain = this.querySelector('tpt-slider-component-sync-main tpt-slider-options').innerHTML;
				const optionStringMainJson = JSON.parse(optionStringMain);

				const optionStringThumbs = this.querySelector('tpt-slider-component-sync-thumb tpt-slider-options').innerHTML;
				const optionStringThumbsJson = JSON.parse(optionStringThumbs);

				var swiperThumbs = new Swiper(swiperThums, { ...optionStringThumbsJson });

				let optionsMain = {
					...optionStringMainJson,
				};

				var swiperMainSlider = new Swiper(swiperMain, {
					...optionsMain,

					thumbs: {
						swiper: swiperThumbs,
					},
				});
			}
		},
	);
}
